/* global localStorage */

import React, { forwardRef, useEffect, useState } from 'react';
import SearchPageProductListItem from './SearchPageProductListItem';
import { array, bool, node, string } from 'prop-types';
import { CgMenuGridR } from 'react-icons/cg';
import { FaList } from 'react-icons/fa';

const DUMMY_PRODUCTS_AMOUNT = 8;

const SearchPageProductList = forwardRef(({ isMobile, productList, searchLoading, collectionHandle, children }, ref) => {
    const [view, setView] = useState('grid');

    const onViewChange = view => {
        setView(view);

        if (typeof window !== 'undefined') {
            localStorage.setItem('view', view);
        }
    };

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const view = localStorage.getItem('view');

        if (view) {
            setView(view);
        }
    }, []);

    return (<ul
        ref={ref}
        className={'search-page--product-list'}>
        <div
            className={'search-page--header-container'}
        >
            {(!searchLoading && productList.length > 0) && (<>
                {children}
                <div>
                    <span
                        style={{marginRight: '1em'}}
                    >
                        View
                    </span>
                    <CgMenuGridR
                        fontSize={'25px'}
                        className={view === 'grid' ? 'active-view' : ''}
                        onClick={() => onViewChange('grid')}
                    />
                    <FaList
                        fontSize={'21px'}
                        className={view === 'list' ? 'active-view' : ''}
                        onClick={() => onViewChange('list')}
                    />
                </div>
            </>)}
        </div>
        {searchLoading === true && (<p
            className={'loading-content'}
            style={{ height: '24px' }}></p>)}
        {(searchLoading === false && !productList.length) && (<p
            style={{ height: '24px' }}>No products found.</p>)}
        <div
            className={`search-page--product-list-inner ${view}`}>
            {(productList.length > 0 && searchLoading === false) && productList.map((product) => (
                <SearchPageProductListItem
                    key={product.id}
                    isMobile={isMobile}
                    title={product.title}
                    handle={product.handle}
                    imageUrl={product.imageUrl}
                    price={product.price}
                    compareAtPrice={product.compareAtPrice}
                    availableForSale={product.availableForSale}
                    avgRating={product.avgRating}
                    totalReviews={product.totalReviews}
                    searchLoading={searchLoading}
                    collectionHandle={collectionHandle}
                    isFeatured={product.isFeatured}
                    inventoryLevelId={product?.availableInventoryLevels?.at(0)?.id ?? 0}
                    availableQuantity={product?.availableInventoryLevels?.at(0)?.availableQuantity ?? 0}
                    bypassNegativeQuantity={product?.availableInventoryLevels?.at(0)?.bypassNegativeQuantity ?? false}
                    view={view}
                />
            ))}
            {searchLoading === true && new Array(DUMMY_PRODUCTS_AMOUNT).fill(0).map((item, idx) => (
                <SearchPageProductListItem
                    key={idx}
                    isMobile={isMobile}
                    searchLoading={searchLoading} />
            ))}
        </div>
    </ul>);
});

SearchPageProductList.displayName = 'SearchPageProductList';

SearchPageProductList.propTypes = {
    isMobile: bool,
    productList: array,
    searchLoading: bool,
    collectionHandle: string,
    children: node,
};

SearchPageProductList.defaultProps = {
    collectionHandle: '',
};

export default SearchPageProductList;